<template>
  <div>
    <CCard>
      <CCardHeader>
        <slot name="header">
          <CIcon name="cil-grid" />
          {{ title }}
        </slot>
      </CCardHeader>
      <CCardBody>
        <Loading v-if="isLoading"></Loading>

        <div v-else>
          <CForm>
            <CRow>
              <CCol sm="3">
                <CInput
                  label="Order Number"
                  invalid-feedback="Order number should be filled"
                  required
                  v-model="$v.OrderForm.order_number.$model"
                  :is-valid="!$v.OrderForm.order_number.$invalid"
                  :readonly="true"
                />
              </CCol>
              <CCol sm="3">
                <div class="form-group">
                  <label for="user_code">User Code</label>
                  <model-select
                    class="form-control"
                    id="user_code"
                    :options="customerList"
                    v-model="$v.OrderForm.user_code.$model"
                    :isError="$v.OrderForm.user_code.$invalid"
                    placeholder="-- Harap pilih salah satu --"
                  ></model-select>
                  <div
                    v-if="$v.OrderForm.user_code.$invalid"
                    class="invalid-feedback-custom"
                  >
                    User code should be filled.
                  </div>
                </div>
              </CCol>

              <CCol sm="3">
                <div class="form-group">
                  <label for="delivery_time">Delivery Time</label>
                  <VueCtkDateTimePicker
                    :id="'delivery_time'"
                    :locale="'ID'"
                    :error="OrderForm.delivery_time === null ? true : false"
                    v-model="OrderForm.delivery_time"
                    :no-label="true"
                    :no-button-now="true"
                    :format="'YYYY-MM-DD hh:mm'"
                  />
                  <div
                    v-if="OrderForm.delivery_time === null ? true : false"
                    class="invalid-feedback-custom"
                  >
                    Delivery Time should be filled.
                  </div>
                </div>
              </CCol>
              <CCol sm="3">
                <div class="form-group">
                  <label for="date_order">Date Order</label>
                  <vc-date-picker
                    id="date_order"
                    :input-props="{
                      class: !$v.OrderForm.date_order.$invalid
                        ? 'form-control is-valid'
                        : 'form-control is-invalid',
                      placeholder: 'Date Order',
                    }"
                    :popover="{ placement: 'top-start' }"
                    :state="!$v.OrderForm.date_order.$invalid"
                    v-model="$v.OrderForm.date_order.$model"
                    :is-required="true"
                  ></vc-date-picker>
                  <div
                    v-if="$v.OrderForm.date_order.$invalid"
                    class="invalid-feedback-custom"
                  >
                    Date order should be filled.
                  </div>
                </div>
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="3">
                <div class="form-group">
                  <label for="delivery">Delivery</label>
                  <model-select
                    class="form-control"
                    id="delivery"
                    :options="deliveryList"
                    v-model="$v.OrderForm.delivery.$model"
                    :isError="$v.OrderForm.delivery.$invalid"
                    placeholder="-- Harap pilih salah satu --"
                  ></model-select>
                  <div
                    v-if="$v.OrderForm.delivery.$invalid"
                    class="invalid-feedback-custom"
                  >
                    Delivery should be filled.
                  </div>
                </div>
              </CCol>

              <CCol sm="3">
                <div class="form-group">
                  <label for="delivery_type">Delivery Type</label>
                  <model-select
                    class="form-control"
                    id="delivery_type"
                    :options="deliveryTypeList"
                    v-model="$v.OrderForm.delivery_type.$model"
                    :isError="$v.OrderForm.delivery_type.$invalid"
                    placeholder="-- Harap pilih salah satu --"
                  ></model-select>
                  <div
                    v-if="$v.OrderForm.delivery_type.$invalid"
                    class="invalid-feedback-custom"
                  >
                    Delivery type should be filled.
                  </div>
                </div>
              </CCol>

              <CCol sm="3">
                <div class="form-group">
                  <label for="payment_method">Payment Method</label>
                  <model-select
                    class="form-control"
                    id="payment_method"
                    :isDisabled="is_agent"
                    :options="paymentMethodList"
                    v-model="$v.OrderForm.payment_method.$model"
                    :isError="$v.OrderForm.payment_method.$invalid"
                    placeholder="-- Harap pilih salah satu --"
                  ></model-select>
                  <div
                    v-if="$v.OrderForm.payment_method.$invalid"
                    class="invalid-feedback-custom"
                  >
                    Payment method should be filled.
                  </div>
                </div>
              </CCol>
              <CCol sm="3">
                <div class="form-group">
                  <label for="status">Status</label>
                  <model-select
                    class="form-control"
                    id="status"
                    :options="orderStatusList"
                    v-model="$v.OrderForm.status.$model"
                    :isError="$v.OrderForm.status.$invalid"
                    placeholder="-- Harap pilih salah satu --"
                  ></model-select>
                  <div
                    v-if="$v.OrderForm.status.$invalid"
                    class="invalid-feedback-custom"
                  >
                    Status should be filled.
                  </div>
                </div>
              </CCol>
            </CRow>
            <CRow>
              
              <CCol sm="3" v-if="OrderForm.status === '6'">
                <CTextarea
                  required
                  rows="4"
                  label="Reason"
                  invalid-feedback="Reason should be filled"
                  v-model="$v.OrderForm.reason.$model"
                  :is-valid="!$v.OrderForm.reason.$invalid"
                />
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="3">
                <CTextarea
                  required
                  rows="4"
                  label="Delivery Address"
                  invalid-feedback="Delivery address should be filled"
                  v-model="$v.OrderForm.delivery_address.$model"
                  :is-valid="!$v.OrderForm.delivery_address.$invalid"
                />
              </CCol>
              <CCol sm="3">
                <CTextarea
                  required
                  rows="4"
                  label="Notes"
                  invalid-feedback="Notes should be filled"
                  v-model="$v.OrderForm.notes.$model"
                  :is-valid="!$v.OrderForm.notes.$invalid"
                />
              </CCol>
              <CCol sm="3" v-if="OrderForm.using_resi === '1'">
                <CInput
                  label="Resi Number"
                  invalid-feedback="Resi number should be filled"
                  required
                  v-model="$v.OrderForm.no_resi.$model"
                  :is-valid="!$v.OrderForm.no_resi.$invalid"
                 
                />
              </CCol>
            </CRow>
          </CForm>
        </div>
      </CCardBody>
      <CCardFooter align="right" :border-color="'white'">
        <CRow>
          <CCol sm="12">
            <CButton
              color="danger"
              title="Edit"
              size="sm"
              class="text-center"
              @click="back"
            >
              <i class="fa fa-undo"></i> Back </CButton
            >&nbsp;
            <CButton
              color="success"
              title="Detail"
              :disabled="$v.OrderForm.$invalid"
              size="sm"
              @click="save"
            >
              <i class="fa fa-edit" /> Save
            </CButton>
          </CCol>
        </CRow>
      </CCardFooter>
    </CCard>

    <CCard>
      <CCardBody>
        <CTabs :active-tab.sync="activeTab">

          <CTab>
            <template slot="title">List Order</template>
            <OrderList v-if="OrderForm.user_code" :items.sync="orderDetailData" :isLoading="loadingTab" :orders="OrderForm"></OrderList>
          </CTab>
          
        </CTabs>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import GlobalTable from "../../templates/Table";
import tableInterfaces from "@/templates/_table_interfaces.js";
import Loading from "../../templates/Loading";
import { required } from "vuelidate/lib/validators";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import vSelect from "vue-select";
import OrderList from "./tabs/OrderList";

export default {
  name: "OrderDetail",
  components: {
    GlobalTable,
    Loading,
    VueCtkDateTimePicker,
    vSelect,
    OrderList,
  },
  data() {
    return {
      title: "Order Detail",
      userList: [],
      customerList: [],
      deliveryList: [],
      deliveryTypeList: [],
      paymentMethodList: [],
      orderStatusList: [],
      orderDetailData: [],
      OrderForm: tableInterfaces.order,
      items: [],
      isLoading: false,
      isEdit: false,
      loadingTab: false,
      addButton: false,
      using_resi: [],
      activeTab: 0,
    };
  },
  validations() {
    if (this.OrderForm.status !== "6") {
      return {
        OrderForm: {
          order_number: { required },
          user_code: { required },
          date_order: { required },
          delivery: { required },
          delivery_type: { required },
          payment_method: { required },
          delivery_address: { required },
          delivery_time: { required },
          notes: {},
          no_resi:{ },
          status: { required },
          reason: {},
        },
      };
    } else {
      return {
        OrderForm: {
          order_number: { required },
          user_code: { required },
          date_order: { required },
          delivery: { required },
          delivery_type: { required },
          payment_method: { required },
          delivery_address: { required },
          delivery_time: { required },
          notes: {},
          no_resi:{ },
          status: { required },
          reason: { required },
        },
      };
    }
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error",
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info",
    },
  },
  computed: {
    is_agent: function () {
      const agent = localStorage.getItem("is_agent");
      return agent === "true" ? true : false;
    },
  },
  methods: {
    init: function (id) {
      this.resetForm();
      this.getDropdown();
      this.getOrderList(id);
      this.getDataOrderDetail(id);
    },
    back: function () {
      this.$router.go(-1);
    },
    getOrderList: function (id) {
      this.isLoading = true;
      this.axios
        .get("console/order/detail/" + id)
        .then((response) => {
          if (response.data.status === 2000) {
            this.OrderForm = response.data.data;
            this.OrderForm.id = id;
            this.OrderForm.date_order = new Date(this.OrderForm.date_order);
            this.showInfoNotification({
              title: this.title,
              message: response.data.message,
            });
          } else {
            this.showErrorNotification({
              title: this.title,
              message: response.data.message,
            });
          }
        })
        .catch((error) => {
          this.showErrorNotification({
            title: this.title,
            message: error,
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    getDataOrderDetail(id) {
      this.loadingTab = true;
      this.axios.get("/console/order/listing_order_detail/" + id).then((response) => {
        this.orderDetailData = response.data.data;
        this.loadingTab = false;
      });
    },
    getDropdown: function () {
      this.axios.get("/console/dropdown/order").then((response) => {
        this.customerList = response.data.users;
        this.deliveryList = response.data.delivery;
        this.deliveryTypeList = response.data.delivery_type;
        this.paymentMethodList = response.data.payment_method;
        this.orderStatusList = response.data.order_status;
        
      });
    },
    resetForm: function () {
      for (var i in tableInterfaces.order) {
        tableInterfaces.order[i] = null;
      }
      this.OrderForm = tableInterfaces.order;
    },
    save: function (evt) {
      evt.preventDefault();
      if (confirm("Apakah anda ingin mengubah detail order ?")) {
        this.isLoading = true;
        this.axios
          .put("console/order/update", this.OrderForm)
          .then((response) => {
            this.showInfoNotification({
              title: "Ubah Detail Order",
              message: response.data.message,
            });
          })
          .catch((error) => {
            this.expired(error, "Ubah Ubah Detail Order");
          })
          .finally(() => {
            this.isLoading = false;
            let route = this.$route.path.split("/");
            this.init(route[4]);
          });
      }
    },
  },
  mounted() {
    let route = this.$route.path.split("/");
    this.init(route[4]);
  },
};
</script>

<style>
.ui.selection.dropdown.error {
  border-color: #e55353;
}
.ui.selection.dropdown {
  border-color: #2eb85c;
}
.ui.selection.dropdown.disabled {
  background-color: #d8dbe0;
  opacity: 0.8;
}
</style>
